import ReceiptIcon from "@mui/icons-material/ReceiptLongOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import type { SvgIconProps } from "@mui/material";
import type { EntriliaProduct } from "@entrilia/shared/api/types";
import CardAccountDetailsIcon from "@entrilia/shared/icons/CardAccountDetailsIcon";
import CorporateAccountingProductIcon from "./CorporateAccountingProductIcon";
import DashboardIcon from "@entrilia/shared/icons/DashboardIcon";
import FundAccountingProductIcon from "./FundAccountingProductIcon";
import PortfolioMonitoringIcon from "./PortfolioMonitoringIcon";
import ReportingProductIcon from "./ReportingProductIcon";

interface Props extends SvgIconProps {
  product: EntriliaProduct;
}

const EntriliaProductIcon = ({ product, ...iconProps }: Props) => {
  switch (product) {
    case "FundAccounting": {
      return <FundAccountingProductIcon {...iconProps} />;
    }
    case "CorporateAccounting": {
      return <CorporateAccountingProductIcon {...iconProps} />;
    }
    case "InvestorRelationsManagement": {
      return <CardAccountDetailsIcon {...iconProps} />;
    }
    case "ReportingPortal": {
      return <ReportingProductIcon {...iconProps} />;
    }
    case "ExpenseManagement": {
      return <ReceiptIcon {...iconProps} />;
    }
    case "PortfolioMonitoring": {
      return <PortfolioMonitoringIcon {...iconProps} />;
    }
    case "CompanyManagement": {
      return <SettingsIcon {...iconProps} />;
    }
    case "Dashboard": {
      return <DashboardIcon {...iconProps} />;
    }
    default: {
      return null;
    }
  }
};

export default EntriliaProductIcon;
